import './js/sprite';
import './js/header';
import './js/categoriesList';
import './js/fondsList';
import './js/slick-slider';
import './js/content';
import './js/modalBook';
import './js/burgerMenu';
import './js/addUserPhoto';
import './js/loginization';
import './js/scrollup';
import './js/footer';
